/*
 * @Author: lixiao
 * @Email: l3936525@163.com
 * @Filename: webpanel/src/config.js
 * @Date: 2021-04-26 15:40:52
 * @Last Modified by: lixiao
 * @Last Modified time: 2021-11-05 10:29:28
 * @Description: 
 */
import config from 'webasercomps/src/defaultConfig';

// const BASE_URL = 'http://nassets.mac.xtarget.org';
// const LOGIN_URL = 'http://nassets.mac.xtarget.org/login.html';
const BASE_URL = 'http://nassets.edaily.work';
const LOGIN_URL = 'http://nassets.edaily.work/login.html';

config.devTool = false; // redux dev tool
config.logo = {
	title: '设备校验标签打印系统',
}
config.context = '/nassets/';
config.api = {
	config: {
		context: '/nassets/api'
	}
}

config.urls = {
	...config.urls,
	base: BASE_URL,
	login: LOGIN_URL
}

config.business = {
	dealer: '605e154e-c2d8-46e4-9833-bfb687af5c15',
}

export default config;